import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { BusinessHoursPanel } from '../components/BusinessHoursPanel';
import { HourlyDistributionPanel } from '../components/HourlyDistributionPanel';
import { HourlyTransitionPanel } from '../components/HourlyTransitionPanel';

// ==================== SVG ICONS ====================

const ClockIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
  </svg>
);

const ChartIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M18 20V10M12 20V4M6 20v-6"/>
  </svg>
);

const DollarIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
  </svg>
);

const HistoryIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
  </svg>
);

// ==================== STYLES ====================

const styles = `
  .horarios-page {
    padding: 0;
  }

  .quick-access-bar {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 16px;
    background: #dbeafe;
    border-left: 4px solid #2563eb;
    border-radius: 6px;
    margin-bottom: 16px;
  }

  .quick-access-label {
    font-size: 0.8rem;
    font-weight: 500;
    color: #1e40af;
  }

  .quick-access-link {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 12px;
    background: #2563eb;
    color: white;
    text-decoration: none;
    border-radius: 4px;
    font-size: 0.8rem;
    font-weight: 500;
    transition: all 0.2s ease;
  }

  .quick-access-link:hover {
    background: #1e40af;
  }

  .quick-access-link svg {
    width: 14px;
    height: 14px;
  }

  .tabs-container {
    display: flex;
    gap: 8px;
    padding: 6px;
    background: #f1f5f9;
    border-radius: 8px;
    margin-bottom: 16px;
  }

  .tab {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 16px;
    border: none;
    background: transparent;
    border-radius: 6px;
    cursor: pointer;
    font-size: 0.85rem;
    font-weight: 500;
    color: #64748b;
    transition: all 0.2s ease;
  }

  .tab:hover {
    background: rgba(59, 130, 246, 0.1);
    color: #3b82f6;
  }

  .tab.active {
    background: white;
    color: #1e40af;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }

  .tab svg {
    flex-shrink: 0;
  }

  .tab-content {
    background: white;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
  }

  @media (max-width: 640px) {
    .quick-access-bar {
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
    }

    .tabs-container {
      flex-direction: column;
    }

    .tab {
      justify-content: center;
    }
  }
`;

export const HorariosPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'hours' | 'distribution' | 'history'>('distribution');

  return (
    <div className="horarios-page">
      <style>{styles}</style>

      {/* Quick Access Bar */}
      <div className="quick-access-bar">
        <span className="quick-access-label">Acceso Rápido:</span>
        <Link to="/monto-diario" className="quick-access-link">
          <DollarIcon />
          Configurar Montos Objetivo
        </Link>
      </div>

      {/* Tabs */}
      <div className="tabs-container">
        <button
          className={`tab ${activeTab === 'hours' ? 'active' : ''}`}
          onClick={() => setActiveTab('hours')}
        >
          <ClockIcon /> Horarios Laborales
        </button>
        <button
          className={`tab ${activeTab === 'distribution' ? 'active' : ''}`}
          onClick={() => setActiveTab('distribution')}
        >
          <ChartIcon /> Distribución por Hora
        </button>
        <button
          className={`tab ${activeTab === 'history' ? 'active' : ''}`}
          onClick={() => setActiveTab('history')}
        >
          <HistoryIcon /> Historial por Hora
        </button>
      </div>

      {/* Content */}
      <div className="tab-content">
        {activeTab === 'hours' && <BusinessHoursPanel />}
        {activeTab === 'distribution' && <HourlyDistributionPanel />}
        {activeTab === 'history' && <HourlyTransitionPanel />}
      </div>
    </div>
  );
};
